import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { LazyNBMPage } from '@confluence/nbm-migration/entry-points/NBMPage.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminNBMMigrationRoute: {
	({ params: { scanId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = ({ params: { scanId } }: RouteMatch): React.JSX.Element => <LazyNBMPage scanId={scanId} />;

AdminNBMMigrationRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'adminNBMMigration' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
